<template>
  <div v-if="!!oAuthEnabled.length">
    <div class="flex flex-wrap justify-center pt-6 mb-9 -mx-6 md:-mx-20">
      <div class="w-full bg-line h-px"></div>
      <div class="text-text-ternary text-2sm px-8 bg-block transform -translate-y-1/2">{{ $t('orSignInWith') }}</div>
    </div>
    <div class="flex justify-center -mx-4">
      <a :href="authLink(item)" class="block hover:opacity-75 cursor-pointer transition duration-200 mx-4"
         v-for="(item,i) in oAuthEnabled" :key="i">
        <img :src="authIcon(item)" alt="">
      </a>
    </div>
  </div>
</template>

<script>
import authIconGoogle from '@/assets/icons/oAuth/google.svg';
import authIconApple from '@/assets/icons/oAuth/appl.svg';
import {auth} from "@/store/resources";
import {mapState} from "vuex";


export default {
  name: "LoginOAuth",
  data() {
    return {
      oAuthEnabled: []
    }
  },
  computed: {
    ...mapState('auth', ['fp']),
  },
  methods: {
    async fetchOAuth() {
      try {
        const res = await auth.oAuthProviders.get();
        this.oAuthEnabled = res.body.data
      } catch (e) {
        console.log(e)
      }
    },
    authIcon(name) {
      switch (name) {
        case 'google':
          return authIconGoogle;
        case 'apple':
          return authIconApple;
      }
    },
    authLink(item) {
      const lang = this.$i18n.locale === 'en' ? 'en' : 'ru';
      return `/api/auth/oauth?provider=${item}&fp=${this.fp.result}&lang=${lang}`;
    }
  },
  created() {
    this.fetchOAuth();
  },
  i18n: {
    messages: {
      en: {
        orSignInWith: 'or sign in with',
      },
      ru: {
        orSignInWith: 'или войти с помощью',
      },
    },
  },
}
</script>